let mainConfig = {
    errorMessages : {
        inputErrorClassName : '_error'
    },
    yandexScriptSrc :'https://api-maps.yandex.ru/2.1/?lang=ru_RU&mode=debug'
};

export default mainConfig; 


// WEBPACK FOOTER //
// ./src/mainConfig.js